import ApartmentOrientationService from '../../services/ApartmentOrientationService'
import BuildingService from '../../services/BuildingService'
import AxiosErrorHandler from '../../helpers/AxiosErrorHandler'
import router from '../../router'

export const namespaced = true

const initialState = {
  apartmentOrientations: [],
  selectedApartmentOrientation: null
}

export const state = {
  apartmentOrientations: [],
  selectedApartmentOrientation: null
}

export const mutations = {
  SET_APARTMENT_ORIENTATIONS(state, recs) {
    state.apartmentOrientations = recs
  },
  SET_SELECTED_APARTMENT_ORIENTATION(state, rec) {
    state.selectedApartmentOrientation = rec
  },
  RESET_STORE(state) {
    Object.assign(state, initialState)
  }
}

export const actions = {
  fetchApartmentOrientations: function(context, value) {
    return BuildingService.getApartmentOrientationsForBuilding(
      context.rootGetters['BuildingStore/getSelectedBuildingId']
    ).then(
      r => {
        context.commit('SET_APARTMENT_ORIENTATIONS', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_APARTMENT_ORIENTATIONS', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  setSelectedApartmentOrientation: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return ApartmentOrientationService.getApartmentOrientationById(value).then(
      r => {
        context.commit('SET_SELECTED_APARTMENT_ORIENTATION', r.data)
        context.dispatch(
          'BreadcrumbsStore/add',
          {
            text: 'APARTMENT ORIENTATION ',
            name: r.data.name
          },
          { root: true }
        )
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_SELECTED_APARTMENT_ORIENTATION', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  addApartmentOrientation: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    return ApartmentOrientationService.addApartmentOrientation(value)
  },
  updateApartmentOrientation: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    return ApartmentOrientationService.updateApartmentOrientation(value).then(
      res => {
        context.commit('SET_SELECTED_APARTMENT_ORIENTATION', res.data)
        context.dispatch(
          'BreadcrumbsStore/update',
          {
            text: 'APARTMENT ORIENTATION ',
            name: res.data.name
          },
          { root: true }
        )
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_SELECTED_APARTMENT_ORIENTATION', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  deleteApartmentOrientation: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    try {
      return await ApartmentOrientationService.deleteApartmentOrientation(value)
    } catch (error) {
      throw error
    }
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  }
}

export const getters = {
  getSelectedApartmentOrientationId: state => {
    return state.selectedApartmentOrientation
      ? state.selectedApartmentOrientation.id
      : 0
  }
}
